import { Search, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { CHANNELS, STAGES } from "@/lib/constants";
import { categoryOptions, servicesInCategory } from "@/lib/categories";

export const EMPTY_FILTERS = { q: "", seller_id: "all", category_id: "all", service_id: "all", stage: "all", channel: "all", date_from: "", date_to: "" };

const FilterSelect = ({ value, onChange, placeholder, options, testid }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger className="h-10 rounded-xl bg-white" data-testid={testid}><SelectValue placeholder={placeholder} /></SelectTrigger>
    <SelectContent>
      <SelectItem value="all">{placeholder}</SelectItem>
      {options.map(([v, l]) => <SelectItem key={v} value={v}>{l}</SelectItem>)}
    </SelectContent>
  </Select>
);

export const LeadFilters = ({ filters, setFilters, services, sellers, showSeller, categories = [] }) => {
  const set = (k) => (v) => setFilters((f) => ({ ...f, [k]: v }));
  const setCategory = (v) => setFilters((f) => ({ ...f, category_id: v, service_id: "all" }));
  return (
    <div className="grid gap-3 rounded-2xl border border-slate-200/80 bg-white p-4 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5" data-testid="lead-filters">
      <div className="relative sm:col-span-2">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
        <Input value={filters.q} onChange={(e) => set("q")(e.target.value)} placeholder="Buscar por nombre, teléfono o correo"
               className="h-10 rounded-xl pl-9" data-testid="lead-search-input" />
      </div>
      {showSeller && (
        <FilterSelect value={filters.seller_id} onChange={set("seller_id")} placeholder="Todos los vendedores" testid="filter-seller"
                      options={[...sellers.map((s) => [s.id, s.name]), ["unassigned", "Sin asignar"]]} />
      )}
      <FilterSelect value={filters.category_id} onChange={setCategory} placeholder="Todas las categorías" testid="filter-category"
                    options={categoryOptions(categories)} />
      <FilterSelect value={filters.service_id} onChange={set("service_id")} placeholder="Todos los servicios" testid="filter-service"
                    options={servicesInCategory(services, filters.category_id).map((s) => [s.id, s.name])} />
      <FilterSelect value={filters.stage} onChange={set("stage")} placeholder="Todos los estados" testid="filter-stage" options={STAGES.map((s) => [s, s])} />
      <FilterSelect value={filters.channel} onChange={set("channel")} placeholder="Todos los canales" testid="filter-channel" options={CHANNELS.map((c) => [c, c])} />
      <Input type="date" value={filters.date_from} onChange={(e) => set("date_from")(e.target.value)} className="h-10 rounded-xl" aria-label="Desde" data-testid="filter-date-from" />
      <div className="flex gap-2">
        <Input type="date" value={filters.date_to} onChange={(e) => set("date_to")(e.target.value)} className="h-10 rounded-xl" aria-label="Hasta" data-testid="filter-date-to" />
        <Button variant="ghost" size="icon" onClick={() => setFilters(EMPTY_FILTERS)} className="h-10 w-10 shrink-0 rounded-xl" aria-label="Limpiar filtros" data-testid="filter-clear-button">
          <X className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};
